import CTLListDefaultCell from "application/components/CTLListDefaultCell";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";

const Attributes = {
  formSize: "md",
  columns: 2,
  enableAddButton: true,
  enableAdvanceSearch: false,
  modes: [],
  settingsMode: false,
};

const operationURLS = {
  list: "userDepartment/list/userDepartmentFilter",
  create: "userDepartment/create",
  delete: "userDepartment/delete",
};

const getColumns = (onEdit, onDelete) => {
  return [
    {
      Header: "User Name",
      accessor: "username",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "multipleSelect",
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "username",
        keyDescription: "username",
        values: [],
        url: "user/dropdownList",
      },
    },
    {
      Header: "Department",
      accessor: "departmentName",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value, row }) => <CTLListDefaultCell value={value} row={row} />,
    },
    {
      Header: "Department",
      accessor: "department",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      controlType: "multipleSelect",
      Cell: ({ value, row }) => <CTLListDefaultCell value={value} row={row} />,
      options: {
        keyField: "code",
        keyDescription: "description",
        values: [],
        url: "department/listAll",
      },
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
